import { collection } from "firebase/firestore";
import { db } from "src/features/firebase/firestore/utils";

const getMeetingRoomsCollection = (clubId, locationId) =>
  collection(db, `clubs/${clubId}/locations/${locationId}/meetingRooms`);

export { getMeetingRoomsCollection };
